<template>
	<div id="app" @click.once="tocarAmbiente">
		<transition name="fade" mode="out-in">
			<router-view></router-view>
		</transition>
		<sound-button></sound-button>
		<boton-info></boton-info>
		<modal-info/>
	</div>
</template>
<script>
import ambiente from "./assets/sounds/ambiente.wav";
import boton from "./assets/sounds/boton.wav";
import open from "./assets/sounds/open2.mp3";
import slide from "./assets/sounds/slide.wav";
import enter from "./assets/sounds/enter.wav";
import pop from "./assets/sounds/pop.mp3";
import SoundButton from "@/components/SoundButton.vue";
import BotonInfo from "@/components/BotonInfo.vue";
import ModalInfo from "@/components/ModalInfo.vue";
// import { setTimeout } from 'timers';

export default {
	components: { 
		SoundButton,
		BotonInfo,
		ModalInfo
	},
	data() {
		return {
			BackGroundAudio: new Audio()
		};
	},
	computed: {
		soundEnabled() {
			return this.$store.getters.soundState;
		}
	},
	methods: {
		tocarAmbiente() {
			this.BackGroundAudio = new Audio(ambiente);
			this.BackGroundAudio.addEventListener(
				"ended",
				function() {
					this.currentTime = 0;
					this.play();
				},
				false
			);

			window.addEventListener("blur", () => {
				this.BackGroundAudio.muted = true;
			});

			window.addEventListener("focus", () => {
				if (this.soundEnabled) {
					this.BackGroundAudio.muted = false;
				}					
			});

			this.BackGroundAudio.play();

			this.BackGroundAudio.volume = 0.5;
		},
		tocar(sonido) {
			if (this.soundEnabled) {
				var audio = new Audio(sonido);
				audio.play();
			}
		}
	},
	mounted() {
		// Listen for the i-got-clicked event and its payload.
		this.$globalEvent.$on("buttonSound", () => {
			this.tocar(boton);
		});
		this.$globalEvent.$on("openSound", () => {
			this.tocar(open);
		});
		this.$globalEvent.$on("enterSound", () => {
			this.tocar(enter);
		});
		this.$globalEvent.$on("slideSound", () => {
			this.tocar(slide);
		});
		this.$globalEvent.$on("popSound", () => {
			this.tocar(pop);
		});
		this.$globalEvent.$on("toggleSound", () => {
			this.$store.commit("toggleSound");
		});
	},
	watch: {
		soundEnabled: function(val) {
			console.log(val);
			this.BackGroundAudio.muted = !val;
		}
	}
};
</script>

<style lang="scss">
#app {
	font-family: "khand", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	// color: #2c3e50;
	width: 100%;
	height: 100%;
	position: fixed;
	overflow: hidden;
	top: 0px;
	left: 0px;
	transition: opacity 0.5s;
}
</style>
